import z from "zod/v4";

/**
 * Codec for boolean values stored as "true"/"false" strings (e.g., in env vars).
 *
 * @example
 * const Schema = z.object({ enabled: BooleanString.default(false) });
 * Schema.parse({ enabled: "true" }); // { enabled: true }
 * Schema.encode({ enabled: true });  // { enabled: "true" }
 */
export const BooleanString = z.codec(z.enum(["true", "false"]), z.boolean(), {
  decode: (v) => v === "true",
  encode: (v): "true" | "false" => (v ? "true" : "false"),
});
